import { gateway } from "../../../../gateway";

export async function sendTwoFaAction({ uid, activationToken, twoFaMethod }) {
  const response = await gateway.post("users/verify-send-twofa", {
    uid,
    activationToken,
    twoFaMethod,
  });
  return response.data;
}
